import { zetApi } from '@zet/network'

export async function getMissingFields(partnerId: string, customerId: number) {
  const { data } = await zetApi.get(
    `get/partnerForm?partnerId=${partnerId}&customerId=${customerId}`
  )

  return data?.data
}

export async function submitMissingFields({ formData, customerId }) {
  const response = await zetApi.post(
    `/save/partnerForm?customerId=${customerId}`,
    formData
  )
}
